import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=4aedc080"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aedc080')) {
      api.createRecord('4aedc080', component.options)
    } else {
      api.reload('4aedc080', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=4aedc080", function () {
      api.rerender('4aedc080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/s/Switch.vue"
export default component.exports